import { render, staticRenderFns } from "./Dispersion.vue?vue&type=template&id=319bc4f3&"
import script from "./Dispersion.vue?vue&type=script&lang=js&"
export * from "./Dispersion.vue?vue&type=script&lang=js&"
import style0 from "./Dispersion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports